import {useEffect} from "react";
import {UseFormReset} from "react-hook-form";
import {TypeGroupPair, Value, type Configuration, type TypeGroups} from "../types";
import {isPairUnavailable} from "../mappers";

const serializeValues = (values: Value[]) => values.map(v => v.code).join(";");

const serializeTypeGroupPairs = (pairs: TypeGroupPair[]) =>
  pairs.map(p => `${p.typeId}:${p.groupId}`).join(";");

export const resetValidation = (
  reset: UseFormReset<Configuration>,
  configuration: Configuration,
  userGroups: Value[],
  userTypes: Value[],
  unavailableTypeGroupPairs: TypeGroupPair[]
) => {
  useEffect(() => {
    const typeGroups = Object.fromEntries(
      userTypes.flatMap(userType =>
        userGroups.map(userGroup => {
          if (isPairUnavailable(unavailableTypeGroupPairs, userType, userGroup)) {
            return [];
          }

          const key = `type_${userType.code}_group_${userGroup.code}`;
          const exists = configuration?.typeGroupPairs?.some(
            pair => pair.typeId === userType.code && pair.groupId === userGroup.code
          );
          return [key, exists ? true : undefined];
        })
      )
    );

    reset({
      ...configuration,
      ...typeGroups,
      typeGroupPairs: undefined
    });
  }, [
    reset,
    configuration,
    serializeValues(userGroups),
    serializeValues(userTypes),
    serializeTypeGroupPairs(unavailableTypeGroupPairs)
  ]);
};
